import { render, staticRenderFns } from "./PlanSummaryPayment.vue?vue&type=template&id=207f7958&scoped=true&"
import script from "./PlanSummaryPayment.vue?vue&type=script&lang=ts&"
export * from "./PlanSummaryPayment.vue?vue&type=script&lang=ts&"
import style0 from "./PlanSummaryPayment.vue?vue&type=style&index=0&id=207f7958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207f7958",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
